import { useState } from "react";

export default function Bathroom({isSmall, defaultValue, errors }) {
  const [selected, setSelected] = useState([]);

  const handleClick = (value) => {
    if (selected.includes(value)) {
      setSelected(selected.filter(v => v !== value)); // снимаем выбор при повторном клике
    } else {
      setSelected([...selected, value]); // выбираем новое значение
    }
  };
  
  return (
    <div className={`bathroom ${errors?.bathroom ? "error" : ""}`}>
      <h5>{isSmall ? "ՍԱՆՀ." : "ՍԱՆՀԱՆԳՈՒՅՑ"}</h5>

      
        <div className="with">
          {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((value, i) => (
            <div key={i}>
              <input
                type="checkbox"
                name="bathroom"
                id={`B${i}`}
                value={value}
                checked={
                  selected.includes(value) ||
                  (!selected && Number(value) === defaultValue)
                } // управляемое состояние
                onChange={() => handleClick(value)} // используем onChange вместо onClick
              />
              <label htmlFor={`B${i}`}>{value}</label>
            </div>
          ))}
        </div>
      
      </div>
  );
}
